import {
    Card, CardContent, Container,
    Link, Stack, TextField, Typography,
    useMediaQuery, Switch,
    Autocomplete
}
    from '@mui/material';
import { LoadingButton } from '@mui/lab';
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { apiInstance } from 'src/utils/apiAuth';
import { showErrorToast, showToast } from 'src/utils/Toast/SnackbarProvider';
import Page from 'src/components/Page';
import axios from 'axios';


export default function AddSenderDetails() {
    const id = useParams();
    const hrToken = localStorage.getItem("authToken");
    const navigate = useNavigate();

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('md'));

    const [countries, setCountries] = useState([]);

    useEffect(() => {
        axios.get("https://restcountries.com/v3.1/all?fields=name")
            .then((res) => {
            const countryNames = res.data.map((country) => country.name.common);
                setCountries(countryNames.sort());
            })
            .catch((err) => console.error("Error fetching countries:", err));
    }, []);

    const [senderDetails, setSenderDetails] = useState([]);
    const getSenderDetails = () => {
        apiInstance({
            method: "get",
            url: "sender-details/" + id.id,
            headers: {
                Authorization: "token " + hrToken,
            }
        })
            .then(function (response) {
                setSenderDetails(response?.data?.data);
            })
            .catch(function (error) {
                showErrorToast(error);
            });
    }

    useEffect(() => {
        if (id?.id) getSenderDetails();
    }, [id, id?.id])

    const callAddSenderDetailsAPI = (formValues) => {
        apiInstance({
            method: "post",
            url: "sender-details/",
            headers: {
                Authorization: "token " + hrToken,
            },
            data: formValues,
        })
            .then(function (response) {
                showToast(response.data.message)
                navigate("/sender-details", { replace: true });
            })
            .catch(function (error) {
                showErrorToast(error);
                setSubmitting(false)
            });
    }

    const callEditSenderDetailsAPI = (formValues) => {
        apiInstance({
            method: "put",
            url: "sender-details/" + id.id + "/",
            data: formValues,
        })
            .then(function (response) {
                showToast(response.data.message);
                navigate("/sender-details", { replace: true });
            })
            .catch(function (error) {
                showErrorToast(error);
                setSubmitting(false);
            });
    }

    useEffect(() => {
        if (id && senderDetails) {
            formik.setValues({
                email: senderDetails?.email || '',
                sender_name: senderDetails?.sender_name || '',
                address: senderDetails?.address || '',
                city: senderDetails?.city || '',
                country: senderDetails?.country || '',
                is_active: senderDetails?.is_active || false,
            });
        }
    }, [id, senderDetails]);

    const Schema = Yup.object().shape({
        email: Yup.string()
            .required("Email required"),
        sender_name: Yup.string()
            .required("Name required."),
        address: Yup.string()
            .required("Address required."),
        city: Yup.string()
            .required("Address required."),
        country: Yup.string()
            .required("Address required."),
        is_active: Yup.string()
            .required("Active status is required."),
    });

    const formik = useFormik({
        initialValues: {
            email: '',
            sender_name: '',
            address: '',
            city: '',
            country: '',
            is_active: false,
        },
        validationSchema: Schema,
        onSubmit: (values) => {
            let formData = {
                "email": values.email,
                "sender_name": values.sender_name,
                "address": values.address,
                "city": values.city,
                "country": values.country,
                "is_active": values.is_active,
            }
            if (id?.id) {
                callEditSenderDetailsAPI(formData)
            } else {
                callAddSenderDetailsAPI(formData)
            }
        }
    });

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, setSubmitting, setFieldValue, handleChange } = formik;

    return (
        <Page title="Add Sender Details">
            <Container maxWidth="xl">
                <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
                    <Link to="/sender-details" color="green" underline="hover" component={RouterLink} fontSize="20px">
                        <ArrowCircleLeftIcon fontSize="large" />
                    </Link>
                    <Typography variant="h4" sx={{ my: matches ? 0 : 3 }} align="center" color="black">
                        {id?.id ? "Update Sender Details" : "Add Sender Details"}
                    </Typography>
                    <div></div>
                </Stack>
                <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                        <Card sx={{ mt: 2, marginInline: 'auto' }} variant="outlined" style={{ width: matches ? '70%' : '50%' }}>
                            <CardContent>
                                <Stack spacing={3}>
                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                        <TextField
                                            fullWidth
                                            required
                                            label="Email"
                                            {...getFieldProps('email')}
                                            error={Boolean(touched.email && errors.email)}
                                            helperText={touched.email && errors.email}
                                        >
                                        </TextField>
                                    </Stack>
                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                        <TextField
                                            fullWidth
                                            required
                                            label="Name"
                                            {...getFieldProps('sender_name')}
                                            error={Boolean(touched.sender_name && errors.sender_name)}
                                            helperText={touched.sender_name && errors.sender_name}
                                        >
                                        </TextField>
                                    </Stack>
                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                        <TextField
                                            fullWidth
                                            required
                                            label="Address"
                                            {...getFieldProps('address')}
                                            error={Boolean(touched.address && errors.address)}
                                            helperText={touched.address && errors.address}
                                        >
                                        </TextField>
                                    </Stack>
                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                        <TextField
                                            fullWidth
                                            required
                                            label="City"
                                            {...getFieldProps('city')}
                                            error={Boolean(touched.city && errors.city)}
                                            helperText={touched.city && errors.city}
                                        >
                                        </TextField>
                                    </Stack>
                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                        <Autocomplete
                                            fullWidth
                                            options={countries}
                                            value={values.country}
                                            onChange={(event, newValue) => {
                                                setFieldValue('country', newValue);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} 
                                                    required
                                                    label="Country"
                                                    {...getFieldProps('country')}
                                                    error={Boolean(touched.country && errors.country)}
                                                    helperText={touched.country && errors.country}/>
                                                )   
                                            }
                                        />
                                    </Stack>
                                    <Stack>
                                        <div role="group" style={{ width: '40%' }}>
                                            <Stack
                                                direction={{ xs: "column", sm: "row" }}
                                                spacing={3}
                                                style={{ padding: "20px 0 0 12px" }}
                                            >
                                                <div id="switch-label" style={{ color: '#637381', marginTop: '5px' }}> Is Active? </div>
                                                <Switch
                                                    name="is_active"
                                                    checked={values.is_active}
                                                    onChange={(event, checked) => {
                                                        setFieldValue("is_active", checked);
                                                    }}
                                                />
                                            </Stack>
                                            <ErrorMessage name="is_active">
                                                {(msg) => <span style={{ color: "#FF4842", fontSize: "12px", marginLeft: 15 }}>{msg}</span>}
                                            </ErrorMessage>
                                        </div>
                                    </Stack>
                                </Stack>

                            </CardContent>
                        </Card>
                        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }} />
                        <LoadingButton
                            size="large"
                            type="submit"
                            variant="contained"
                            loading={isSubmitting}
                            style={{ display: "block", margin: "auto", width: 400 }}
                        >
                            {id?.id ? "Update Sender Details" : "Add Sender Details"}
                        </LoadingButton>
                    </Form>
                </FormikProvider>
            </Container>
        </Page >
    )
}